import { render, staticRenderFns } from "./VatView.vue?vue&type=template&id=392a573e&scoped=true"
import script from "./VatView.vue?vue&type=script&lang=js"
export * from "./VatView.vue?vue&type=script&lang=js"
import style0 from "./VatView.vue?vue&type=style&index=0&id=392a573e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a573e",
  null
  
)

export default component.exports